import React from 'react';
export function TermsConditions() {
  return <div className="space-y-4 text-sm text-slate-600" data-id="element-107">
      <p data-id="element-108">Last updated: December 2024</p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-109">
        1. Agreement to Terms
      </h4>
      <p data-id="element-110">
        By accessing our website, you agree to be bound by these Terms and
        Conditions and agree that you are responsible for compliance with any
        applicable local laws.
      </p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-111">
        2. Use License
      </h4>
      <p data-id="element-112">
        Permission is granted to temporarily download one copy of the materials
        (information or software) on Santa's Certified Letter's website for
        personal, non-commercial transitory viewing only.
      </p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-113">
        3. Disclaimer
      </h4>
      <p data-id="element-114">
        The materials on Santa's Certified Letter's website are provided on an
        'as is' basis. Santa's Certified Letter makes no warranties, expressed
        or implied, and hereby disclaims and negates all other warranties
        including, without limitation, implied warranties or conditions of
        merchantability, fitness for a particular purpose, or non-infringement
        of intellectual property or other violation of rights.
      </p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-115">
        4. Limitations
      </h4>
      <p data-id="element-116">
        In no event shall Santa's Certified Letter or its suppliers be liable
        for any damages (including, without limitation, damages for loss of data
        or profit, or due to business interruption) arising out of the use or
        inability to use the materials on Santa's Certified Letter's website.
      </p>

      <h4 className="text-lg font-semibold text-slate-900 mt-4" data-id="element-117">
        5. Revisions
      </h4>
      <p data-id="element-118">
        The materials appearing on Santa's Certified Letter's website could
        include technical, typographical, or photographic errors. Santa's
        Certified Letter does not warrant that any of the materials on its
        website are accurate, complete or current.
      </p>
    </div>;
}